

























































































import { Component, Vue } from "vue-property-decorator";
import Base64 from "@/common/base64.ts";
import { wxChatShare } from "@/common/wechat.ts";
import { Tab, Tabs, Loading, List } from "vant";
import request from "@/api/index";
@Component({
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Loading.name]: Loading,
    vanList: List
  }
})
export default class ColumnList extends Vue {
  columnInfo: any; // 父元素信息
  columnImg = ""; //父元素banner
  listLoading: boolean = true;
  finished: boolean = false;
  columnId = ""; // 列表栏目id
  newsList = []; // 新闻列表
  mounted() {
    this.columnId = this.$route.query.columnId as string;
    this.getNewsList();
    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.bottomBarConfig({
        isShowBottom: 0
      });
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "南岸区疫情防控专题",
        isShowMoreBtn: "1"
      });
      ZWY_CLOUD.shareConfig({
        id: "",
        shareTitle: "南岸区疫情防控专题",
        shareDescription: "众志成城 守望相助  坚决打赢疫情歼灭战",
        sourceType: "1",
        shareImgUrl: "https://imagecdn.cqliving.com/images/icon/4.png",
        shareUrl: window.location.href,
        shareUrlQQ: window.location.href,
        shareUrlQzone: window.location.href,
        shareUrlWx: window.location.href,
        shareUrlWxMoments: window.location.href,
        shareUrlWeibo: window.location.href
      });
    } else {
      document.title = "疫情防控";
      wxChatShare(
        "疫情防控",
        "描述",
        window.location.href,
        "https://imagecdn.cqliving.com/images/icon/4.png"
      );
    }
  }
  getNewsList() {
    let lastId: string = "";
    let lastSortNo: string = "";
    let lastOnlineTime: string = "";
    if (this.newsList && this.newsList.length > 0) {
      let lastItem: any = this.newsList[this.newsList.length - 1];
      lastId = String(lastItem["id"]);
      lastSortNo = String(lastItem["sortNo"]);
      lastOnlineTime = String(lastItem["onlineTime"]);
    }
    request
      .getNewsList("4", this.columnId, lastId, lastSortNo, lastOnlineTime)
      .then(res => {
        if (res.code == 0 && res.data) {
          if (res.data.news.length < 10) {
            this.finished = true;
          }
          this.listLoading = false;
          this.newsList = this.newsList.concat(res.data.news);
        }
      });
  }

  intoDetail(item: any) {
    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.redirectUrl({
        id: item.id,
        sourceId: item.informationId,
        detailViewType: item.detailViewType,
        sourceType: item.sourceType,
        commentType: item.commentType,
        contextType: item.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "1",
        url: item.url,
        shareUrl: item.shareUrl,
        title: Base64.encode(item.title), //base 64
        synopsis: Base64.encode(item.synopsis), //base 64
        shareImgUrl: item.shareImgUrl
      });
    } else {
      window.location.href = item.url;
    }
  }

  onListLoad() {
    if (this.newsList.length == 0) {
      return;
    }
    this.getNewsList();
  }
}
